'use client';

import Popup from '@/components/Popup/Popup';
import { useGlobalOverlayContent } from '@/hooks/useGlobalOverlayContent';
import type { PartialPopupStoryblok } from '@/types/component-types-sb';

type PartialPopupProps = {
  blok: PartialPopupStoryblok;
  onClose: () => void;
};

const PartialPopup: React.FC<PartialPopupProps> = ({ blok, onClose }) => {
  const content = useGlobalOverlayContent(blok);

  if (!content) {
    return null;
  }

  return (
    <Popup
      open
      onClose={onClose}
      title={content.title}
      text={content.text}
      ctaText={content.hasCta ? content.ctaText : undefined}
      ctaHref={content.hasCta ? content.ctaHref : undefined}
      ctaTarget={content.ctaTarget}
    />
  );
};

export default PartialPopup;
